module.exports = __webpack_public_path__ + "static/media/ico-computer.97d03bdd.svg";